module.exports = "<div class=\"igx-snackbar\" *ngIf=\"isVisible\" (@slideInOut.start)=\"snackbarAnimationStarted($event)\" (@slideInOut.done)=\"snackbarAnimationDone($event)\"\n    [@slideInOut]=\"isVisible\">\n    <span class=\"igx-snackbar__message\" [@fadeInOut]=\"isVisible\">{{ message }}</span>\n    <button class=\"igx-snackbar__button\" igxRipple=\"white\" *ngIf=\"actionText\" [@fadeInOut] (click)=\"triggerAction(snackbar)\">\n            {{ actionText }}\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/snackbar/snackbar.component.html
// module id = 126
// module chunks = 0 1